<div id="main-navigation" class="nav" [ngClass]="{'horizontal':layout === 'horizontal'}">

    <ng-container *ngIf="layout === 'vertical'">

        <ng-container *ngFor="let item of verticalNavigation">

            <eguard-nav-vertical-subheader *ngIf="item.type=='subheader'" [item]="item"></eguard-nav-vertical-subheader>
            <eguard-nav-vertical-item *ngIf="item.type=='nav-item'" [item]="item"></eguard-nav-vertical-item>
            <!-- <eguard-nav-vertical-collapse *ngIf="item.type=='nav-collapse'" [item]="item"></eguard-nav-vertical-collapse> -->

        </ng-container>

    </ng-container>

</div>


// WEBPACK FOOTER //
// ./src/app/core/components/navigation/navigation.component.html